/**
* 首页、告警升级列表相关的reducer方法
*/

import { combineReducers } from 'redux';
import {
  SET_CITY_INDEXDATA,
  SET_CHANGE_INDEXDATA,
  SET_DEPART_INDEXDATA,
  SET_CHANGE_DEPTINDEXDATA,
  GETREPORTERRORDATA,
  GETUSERINFOBYTOKEN,
  GETREPORTERRORDATAUI_EQUIPMENTTYPES,
  GETREPORTERRORDATAUI_ORGANIZATIONS,
  SET_LINSHIDATA,
  SET_LINSHINODE,
  SET_LINSHINAME,
  SET_NEWNAVBAR_COMPONENT,
  SET_BUSOBDEFNAMES,
  SET_BUSOBDEFFIELD,
  SET_INDEX_TOURL,
  SET_USER_COMPONENT_STATE,
  SET_USER_Depart_IS_SAVED,
  SET_CURRENT_ALARMUPGRADEDATA,
  SET_ALARMUPLOADDETAILSDATA,
  SET_ALARMUPLOADLOGDATA,
  SET_ALARMUPLOADLOG_SUPERVISIONDATA
} from '../actions/index_action'

//wei
function userComponentState(state = [], action) {
  switch (action.type) {
    case SET_USER_COMPONENT_STATE:
      return action.userComponentState;
    default:
      return state;
  }
}

function userDepartIsSave(state = '', action){
  switch (action.type) {
    case SET_USER_Depart_IS_SAVED:
      return action.userDepartIsSave;
    default:
      return state;
  }
}

function busObDefField(state = [], action) {
  switch (action.type) {
    case SET_BUSOBDEFFIELD:
      return action.data;
    default:
      return state;
  }
}
function busObDefNames(state = [], action) {
  switch (action.type) {
    case SET_BUSOBDEFNAMES:
      return action.data;
    default:
      return state;
  }
}
function cityIndexData(state = '', action) {
    switch (action.type) {
        case SET_CITY_INDEXDATA:
          return action.data;
        case SET_CHANGE_INDEXDATA:
          return Object.assign({},state,{
              monitorData: action.data
          });
        default:
          return state
    }
}
function departmentIndexData(state = '', action) {
    switch (action.type) {
        case SET_DEPART_INDEXDATA:
          return action.data;
        case SET_CHANGE_DEPTINDEXDATA:
          return Object.assign({},state,{
              statusData: action.data
          });
        default:
          return state
    }
}

function reportErrorData(state = [], action) {
    switch (action.type) {
        case GETREPORTERRORDATA:
          return action.reportErrorData;
        default:
          return state
    }
};

function equipmentTypes(state =[] , action) {
    switch (action.type) {
        case GETREPORTERRORDATAUI_EQUIPMENTTYPES:
          return action.equipmentTypes;
        default:
          return state
    }
};

function organizations(state =[] , action) {
    switch (action.type) {
        case GETREPORTERRORDATAUI_ORGANIZATIONS:
          return action.organizations;
        default:
          return state
    }
};

function linshiData(state ='' , action) {
    switch (action.type) {
        case SET_LINSHIDATA:
          return action.data;
        default:
          return state
    }
};

function linshiNode(state ='' , action) {
    switch (action.type) {
        case SET_LINSHINODE:
          return action.data;
        default:
          return state
    }
};

function linshiName(state ='' , action) {
    switch (action.type) {
        case SET_LINSHINAME:
          return action.data;
        default:
          return state
    }
};

function newnavbarcomponent(state = null , action) {
    switch (action.type) {
        case SET_NEWNAVBAR_COMPONENT:
          return action.newnavbarcomponent;
        default:
          return state
    }
};

//设置跳转路由
function toUrl(state = "", action) {
    switch (action.type) {
        case SET_INDEX_TOURL:
            return action.toUrl
        default:
            return state
    }
};
function currentAlarmUpgradeData(state = null , action) {
    switch (action.type) {
        case SET_CURRENT_ALARMUPGRADEDATA:
          return action.currentAlarmUpgradeData;
        default:
          return state
    }
};
function alarmUploadDetailsData(state = [] , action) {
    switch (action.type) {
        case SET_ALARMUPLOADDETAILSDATA:
          return action.alarmUploadDetailsData;
        default:
          return state
    }
};
function alarmUploadLogData(state = [] , action) {
    switch (action.type) {
        case SET_ALARMUPLOADLOGDATA:
          return action.alarmUploadLogData;
        default:
          return state
    }
};
function alarmUploadSupervisionData(state = [] , action) {
    switch (action.type) {
        case SET_ALARMUPLOADLOG_SUPERVISIONDATA:
          return action.alarmUploadSupervisionData;
        default:
          return state
    }
};

const indexReducer = combineReducers({
    cityIndexData,
    departmentIndexData,
    reportErrorData,
    equipmentTypes,
    organizations,
    linshiData,
    linshiNode,
    linshiName,
    newnavbarcomponent,
    busObDefNames,
    busObDefField,
    toUrl,
    userComponentState,
    userDepartIsSave,
    currentAlarmUpgradeData,
    alarmUploadDetailsData,
    alarmUploadLogData,
    alarmUploadSupervisionData
})

export default indexReducer
